var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0583 4.79248C16.525 2.98415 15.0167 1.47582 13.2083 0.942482C11.8333 0.542482 10.8833 0.575815 10.225 1.06748C9.43334 1.65915 9.34167 2.72582 9.34167 3.48415V5.55915C9.34167 7.60915 10.275 8.65082 12.1083 8.65082H14.5C15.25 8.65082 16.325 8.55915 16.9167 7.76748C17.425 7.11748 17.4667 6.16748 17.0583 4.79248Z",
    fill: "#075453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7583 10.1349C14.5416 9.88492 14.225 9.74326 13.9 9.74326H10.9166C9.44998 9.74326 8.25831 8.55159 8.25831 7.08492V4.10159C8.25831 3.77659 8.11664 3.45992 7.86664 3.24326C7.62498 3.02659 7.29164 2.92659 6.97498 2.96826C5.01664 3.21826 3.21664 4.29326 2.04164 5.90992C0.85831 7.53492 0.424976 9.51826 0.799976 11.5016C1.34164 14.3683 3.63331 16.6599 6.50831 17.2016C6.96664 17.2933 7.42498 17.3349 7.88331 17.3349C9.39164 17.3349 10.85 16.8683 12.0916 15.9599C13.7083 14.7849 14.7833 12.9849 15.0333 11.0266C15.075 10.7016 14.975 10.3766 14.7583 10.1349Z",
    fill: "#075453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSelected);
export default __webpack_public_path__ + "static/media/dashboardSelected.12ef2a6bc794e68254e3b22c9b4fe61f.svg";
export { ForwardRef as ReactComponent };